export default {
  logo: require("../assets/images/logo.png"),
  ClientRetention: require("../assets/images/clientretention1.webp"),
  ClientRetention2: require("../assets/images/clientretention2.webp"),
  NextSection: require("../assets/images/next1.webp"),
  AwardsOne: require("../assets/images/awards1.png"),
  Awardssecnd: require("../assets/images/awards2.png"),
  Awardsthrd: require("../assets/images/awards3.png"),
  Awardsfr: require("../assets/images/awards4.png"),
  Engimg: require("../assets/images/finance-banking.webp"),
  ReviewImg: require("../assets/images/review.png"),
  RChechImg1: require("../assets/images/check_1.png"),
  RChechImg2: require("../assets/images/check_2.png"),
  RChechImg3: require("../assets/images/check_3.png"),
  StudyList: require("../assets/images/study_list.png"),
  Img1: require("../assets/images/01.png"),
  Img2: require("../assets/images/02.png"),
  Img3: require("../assets/images/03.png"),
  Img4: require("../assets/images/04.png"),
  Img5: require("../assets/images/05.png"),
  Img6: require("../assets/images/06.png"),
  Approch: require("../assets/images/approch.png"),
  PopupImg: require("../assets/images/popupimg.png"),
  Graph: require("../assets/images/graph.png"),
  Whoimg: require("../assets/images/whoimg.png"),
  Guiding: require("../assets/images/guiding.png"),
  BannerUser: require("../assets/images/banneruser.png"),
  Built: require("../assets/images/built.png"),
  Vision: require("../assets/images/vision.png"),
  Mission: require("../assets/images/mission.png"),
  Empower: require("../assets/images/empower.png"),
  Trusted: require("../assets/images/trusted.png"),
  resultsDriven: require("../assets/images/results-driven.png"),
  Innovativesolutions: require("../assets/images/innovativesolutions.png"),
  Industries: require("../assets/images/shapping.png"),
  Tail: require("../assets/images/tail.png"),
  Partner: require("../assets/images/partner.png"),
  Serend: require("../assets/images/ser_end.png"),
  Ios: require("../assets/images/ios.png"),
  Android: require("../assets/images/android.png"),
  Hybrid: require("../assets/images/hybrid.png"),
  Sermedia: require("../assets/images/ser_media.png"),
  Serdating: require("../assets/images/ser_dating.png"),
  Serads: require("../assets/images/ser_ads.png"),
  Serdating: require("../assets/images/ser_dating.png"),
  Serecom: require("../assets/images/ser_ecom.png"),
  Serhealth: require("../assets/images/ser_health.png"),
  Serbuild: require("../assets/images/ser_build.png"),

  Sertrans: require("../assets/images/ser_trans.png"),
  Who1: require("../assets/images/who1.png"),
  Who2: require("../assets/images/who2.png"),
  Who3: require("../assets/images/who3.png"),
  Who4: require("../assets/images/who4.png"),
  Who5: require("../assets/images/who5.png"),
  Whogirl: require("../assets/images/who_girl.png"),
  Whoteam: require("../assets/images/who_team.png"),
  AndooidImg: require("../assets/images/android1.png"),
  Swift: require("../assets/images/swift.png"),
  ObjImg: require("../assets/images/obj.png"),
  JavaImg: require("../assets/images/java.png"),
  SettingImg: require("../assets/images/setting.png"),
  KotlinImg: require("../assets/images/kotlin.png"),
  eCommerce_development: require("../assets/images/eCommerce_development.webp"),
  on_demand_app_Development: require("../assets/images/on_demand_app_Development.webp"),
  digital_marketing: require("../assets/images/digital_marketing.webp"),
  cloud_engineering: require("../assets/images/cloud_engineering.webp"),
  product_engineering: require("../assets/images/product_engineering.webp"),
  staff_augmentation: require("../assets/images/staff_augmentation.webp"),
  health_care: require("../assets/images/health_care.webp"),
  education: require("../assets/images/education.webp"),
  logistics: require("../assets/images/logistics.webp"),
  on_demand: require("../assets/images/on_demand.webp"),
  travel: require("../assets/images/travel.webp"),
  real_estate: require("../assets/images/real_estate.webp"),
  ecommerce: require("../assets/images/ecommerce.webp"),
  media_entertainment: require("../assets/images/media_entertainment.webp"),
  government: require("../assets/images/government.webp"),
  automotive: require("../assets/images/automotive.webp"),
  fintech: require("../assets/images/fintech.webp"),
  sports: require("../assets/images/sports.webp"),
  top_overlay: require("../assets/images/top_overlay.webp"),
  no_news_found: require("../assets/images/no_news_found.png"),
};
